import { getCrossMerchantTransferPathExport } from "../../../../api/merchant";
import GeneralBtn from "../../../../components/GeneralBtn";
import { Box, Container } from "../../../../components/MuiGenerals";
import TableTab from "../../../../components/TableTab";
import { useAlerting, usePermission, useTranslation } from "../../../../hooks";
import { downloadFiles, getFullApiResponse } from "../../../../utils/helper";
import { DivideLine } from "../../../../utils/HelperComp";
import { customSx } from "../../../../utils/styling";
import { Pkey, translatePrefix } from "../config";
import { useReduxContext } from "../reduxContext";
import useLiquidityProviderTabQuery from "../useLiquidityProviderTabQuery";
import useListMapping from "./helpers/useListMapping";
import ViewFilter from "./ViewFilter";
import ViewTable from "./ViewTable";

const LiquidityProviderTab = () => {
  const { hasPermission } = usePermission();
  const { alerting } = useAlerting();
  const { tc } = useTranslation(translatePrefix);
  const { data } = useLiquidityProviderTabQuery();
  const listMapping = useListMapping();

  const [state] = useReduxContext();

  const onExport = async () => {
    const { count = 0 } = data ?? {};
    if (count === 0) {
      return alerting("error", tc("no_data_export"));
    }
    const apiFn = (page: number, pageSize: number, signal: any) =>
      getCrossMerchantTransferPathExport(
        { ...state.params, page, pageSize },
        { signal }
      );
    const rawRes = await getFullApiResponse(apiFn, count, true);
    if (rawRes.length === 0) return;
    const omitKeys = ["rawData"];
    const res = listMapping("name", rawRes, {
      omitKeys,
    });
    const config = {};
    downloadFiles(`Cross Merchant Transfer Path`, res, config);
  };

  return (
    <Box sx={customSx.layoutBox}>
      <Container disableGutters maxWidth={false}>
        <ViewFilter />
      </Container>
      <DivideLine />
      <Container
        style={customSx.datagridContainer}
        maxWidth={false}
        disableGutters
      >
        <Box sx={customSx.tableExportBar}>
          {hasPermission(Pkey.TabLiquidityProvider.Export) && (
            <GeneralBtn label="export" onClick={onExport} />
          )}
        </Box>
        <TableTab>
          <ViewTable />
        </TableTab>
      </Container>
    </Box>
  );
};

export default LiquidityProviderTab;
